import * as go from 'gojs';

export const deleteNodeGroupNode = (group: go.Node) => {
  if (!group?.diagram || !(group instanceof go.Group) || !group.canDelete()) {
    return;
  }

  group.diagram.commandHandler.addTopLevelParts(group.memberParts);
  group.diagram.remove(group);
};
